import { Injectable } from '@angular/core';
import {
  DataAnalyticsTaggingEventType,
  DataAnalyticsTaggingEvent,
  GamlAttestationAnalytics,
  GamlAttestationEntryPoint,
  GamlAttestationFlowType,
  GamlAttestationEditSection
} from '@tdwb/core';

@Injectable()
export class WebbrokerGamlAttestationAnalytics extends GamlAttestationAnalytics {

  readonly GAML_ATTESTATION_BANNER_EVENT: DataAnalyticsTaggingEvent = {
    event: DataAnalyticsTaggingEventType.LINK_CLICK,
    link: {
      type: 'link',
      name: 'tdw:wbt:gaml:<60 day:banner update'
    }
  }

  readonly GAML_ATTESTATION_HALT_TRADE_BANNER_EVENT: DataAnalyticsTaggingEvent = {
    event: DataAnalyticsTaggingEventType.LINK_CLICK,
    link: {
      type: 'link',
      name: 'tdw:wbt:gaml:>60 day:banner update'
    }
  }

  constructor() {
    super();
  }

  getGamlAttestationFlowType(entryPoint: GamlAttestationEntryPoint, isGamlEditClicked: boolean = false): GamlAttestationFlowType {
    let flowType: GamlAttestationFlowType;

    if(entryPoint === 'GAML_ATTESTATION_BANNER') {
      flowType = '<60day';
    } else if (entryPoint === 'GAML_ATTESTATION_HALT_TRADE_BANNER') {
      flowType = '>60day';
    } else if (isGamlEditClicked) {
      flowType = 'flow b';
    } else {
      flowType = 'flow c';
    }

    return flowType;
  }

  getGamlAttestationLoadEvent(flowType: GamlAttestationFlowType): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'gaml',
        subSection1: 'home',
        subSection2: 'summary',
        flowType,
        customPageName: 'wb_modal-gaml'
      }
    }
  }

  getGamlAttestationSuccessLoadEvent(flowType: GamlAttestationFlowType): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'gaml success',
        subSection1: 'home',
        subSection2: 'summary',
        flowType,
        customPageName: 'wb_modal-gaml-success'
      }
    }
  }

  getGamlAttestationModalCloseEvent(flowType: GamlAttestationFlowType): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.LINK_CLICK,
      link: {
        type: 'link',
        name: `tdw:wbt:gaml:close:${flowType}`
      }
    };
  }

  getGamlAttestationEditEvent(section: GamlAttestationEditSection): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.LINK_CLICK,
      link: {
        type: 'link',
        name: `tdw:wbt:gaml:${section}`
      }
    };
  }
}